  <p id="report-format-group-label">
    {{ label }}
  </p>

  <mat-radio-group class="report-format-group">
    @for (format of selectOptions; track format) {
    <mat-radio-button [color]="'primary'" [checked]="defaultOption === format" [value]="format" (change)="selectedValue($event)">
      {{ format }}
    </mat-radio-button>
    }
  </mat-radio-group>

  <mat-error *ngIf="customErrorMessage">
    {{ customErrorMessage }}
  </mat-error>